/*@flow*/
import * as t from 'lib/t';
import enumsFor from './util/enumsFor';
import { Id } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  theGeom: t.String.opt({ type: 'hidden' }),
  address: t.maybe(t.String).opt({
    label: 'Nearest Address',
    template: 'LocationPickerTemplate',
  }),
  mapLabel: t.maybe(t.String),
  radiusMeters: t.maybe(t.Number).opt({
    label: 'Radius in meters',
    help: 'Used to indicate the perimeter of an asset.',
  }),
  redirectUrl: t.maybe(t.String).opt({
    type: 'url',
    label: 'Redirect URL (QR Code)',
    help: 'When QR code is scanned, the user will be redirected here.',
  }),
  status: t.String.options({
    template: 'StreetscapeAssetStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  visibility: enumsFor('visibility'),
  category: t.String.opt({
    label: 'Asset Type',
    template: 'AssetType',
    attrs: {
      placeholder: 'Choose an asset type',
    },
  }),
  subcategories: t.maybe(t.list(t.String)).opt({
    label: 'Asset Subtype',
    template: 'AssetSubtype',
    attrs: {
      placeholder: 'Choose an asset subtype',
    },
  }),
  cost: t.maybe(t.Number).opt({
    label: 'Cost',
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('streetscape_assets'),

    attrs: {
      placeholder: 'Select...',
    },
  }),
  photoUrls: t.maybe(t.list(t.String)).opt({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  notes: t
    .maybe(t.String)
    .opt({ type: 'textarea', template: 'TextEditorTemplate' }),
};
export default t.struct(config, 'StreetscapeAsset').opt<any>({
  legend: '',
  order: [
    'id',
    'category',
    'status',
    'visibility',
    'address',
    'radiusMeters',
    'redirectUrl',
    'subcategories',
    'tags',
    'photoUrls',
    'notes',
    'mapLabel',
  ],
});
